import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=2d203d3e&scoped=true";
import script from "./UserDetail.vue?vue&type=script&lang=js";
export * from "./UserDetail.vue?vue&type=script&lang=js";
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=2d203d3e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2d203d3e", null);
export default component.exports;